import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TooltipProvider } from "beproduct-ui";
import { Toaster } from "sonner";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <TooltipProvider>
      <Outlet />
      {/*
       * Every toast.success / toast.error in this app renders here. Without
       * this mounted once at the root, sonner accepts the calls and shows
       * nothing — saves, failures and copy confirmations all land silently,
       * which is indistinguishable from the action not having run.
       *
       * It must be sonner's own Toaster, NOT beproduct-ui's: the library
       * bundles its own copy of sonner (a different major version), so its
       * Toaster subscribes to a different toast store than our toast() calls
       * publish to — it mounts, renders, and stays empty forever.
       *
       * Theme comes from the class index.html sets before React boots, which
       * is the same localStorage key the rest of the app reads.
       */}
      <Toaster
        theme={
          typeof document !== "undefined" &&
          document.documentElement.classList.contains("dark")
            ? "dark"
            : "light"
        }
      />
    </TooltipProvider>
  ),
});
